export class Navigator {
    public version: string = undefined;
    public platform: string = undefined;
    public locale: string = undefined;
}
